import { trackTermsOfUse } from 'actions';
import { Accept } from 'components/Accept/Accept';
import { useFlysiteUrls } from 'hooks/useFlysiteUrls/useFlysiteUrls';
import type { ChangeEvent } from 'react';
import { type ConnectedProps, connect } from 'react-redux';
import { useTranslations } from 'utils';

type TermsAndConditionsProps = ConnectedProps<typeof connector> & {
  checked?: boolean;
  error?: boolean | string;
  name?: string;
  onChange?: (evt: ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
};

function TermsAndConditionsComponent({
  checked,
  error,
  name,
  onChange,
  required,
  trackTermsOfUse,
}: TermsAndConditionsProps) {
  const i18n = useTranslations();

  const { privacyUrl, termsUrl } = useFlysiteUrls();

  const termsOfUseLink = (
    <a
      className="Link"
      href={termsUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="termsOfUseLink"
      onClick={() => trackTermsOfUse('terms of use')}
    >
      {i18n.t('termsAndConditions.terms_of_use')}
    </a>
  );

  const privacyPolicyLink = (
    <a
      className="Link"
      href={privacyUrl}
      target="_blank"
      data-testid="privacyPolicyLink"
      rel="noopener noreferrer"
      onClick={() => trackTermsOfUse('privacy policy')}
    >
      {i18n.t('termsAndConditions.privacy_policy')}
    </a>
  );

  return (
    <Accept
      checked={checked}
      error={error ? 'termsAndConditions.error' : undefined}
      onChange={onChange}
      name={name}
      required={required}
    >
      {i18n.t('termsAndConditions.terms_read')} {termsOfUseLink}{' '}
      {i18n.t('termsAndConditions.and')} {privacyPolicyLink}
    </Accept>
  );
}

const mapDispatchToProps = {
  trackTermsOfUse,
};
const connector = connect(undefined, mapDispatchToProps);

export const TermsAndConditions = connector(TermsAndConditionsComponent);
